import { render, staticRenderFns } from "./IntroductionOfficePage.vue?vue&type=template&id=b5d869f8&scoped=true&"
import script from "./IntroductionOfficePage.vue?vue&type=script&lang=js&"
export * from "./IntroductionOfficePage.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionOfficePage.vue?vue&type=style&index=0&id=b5d869f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d869f8",
  null
  
)

export default component.exports